import React, {useState,useEffect} from 'react';
//import './css/ready.css';
import { useLocation } from 'react-router-dom';
import { dwvideofromWebService} from './services/SendImageService';

function getFilenameFromURL(fileUrl) {
  if (!fileUrl || typeof fileUrl !== 'string') return '';
  const lastSlashIndex = fileUrl.lastIndexOf('/');
  return lastSlashIndex !== -1 ? fileUrl.substring(lastSlashIndex + 1) : fileUrl;
}

function Ready() {
  const location = useLocation();
  const [videolink, setvideolink] = useState();
  
 

  useEffect(() => {
    console.log("Ready Page Location:", location);
    if (location.state && location.state.forreadyvideo) {
      let data = location.state.forreadyvideo;
      console.log("Received video data:", data);

      let fileUrl = data;
      // If data is a JSON string containing video_url, parse it
      if (typeof data === 'string') {
          try {
              const parsed = JSON.parse(data);
              if (parsed.video_url) {
                  fileUrl = parsed.video_url;
              } else if (parsed.url) {
                  fileUrl = parsed.url;
              } else if (parsed.error && parsed.errmsg) {
                  console.error("API returned Error:", parsed.errmsg);
                  alert("Error generating video: " + parsed.errmsg);
                  return;
              }
          } catch(e) {
              // It's a plain string
          }
      } else if (typeof data === 'object' && data !== null) {
         if (data.error && data.errmsg) {
             console.error("API returned Error:", data.errmsg);
             alert("Error generating video: " + data.errmsg);
             return;
         }
         // Handle object structure { video_url: "...", video_id: "..." }
         if (data.video_url) {
             fileUrl = data.video_url;
         } else {
             console.warn("Object received but no video_url property found", data);
         }
      }

      // If fileUrl is still an object here, it means we didn't find a valid URL.
      if (typeof fileUrl === 'object') {
          console.error("Invalid response format, unable to extract video link.", data);
          alert("Sorry, the server returned an invalid response and the video could not be processed.");
          return;
      }

      // Clean up fileUrl if it somehow still had quotes or brackets
      if (typeof fileUrl === 'string') {
         fileUrl = fileUrl.replace(/["'{}]/g, '');
      }

      const filename = getFilenameFromURL(fileUrl);
      if (filename) {
        // Strip any trailing characters that might be appended after .mp4 if parsing failed slightly
        const cleanFilename = filename.split(',')[0]; 
        
        // Failsafe check
        if (!cleanFilename) {
           alert("Video generation failed. Please try again.");
           return;
        }

        let fulllink = "https://generateaivideo.stellans.com/api/video?v=" + cleanFilename;
        console.log("Generated Link:", fulllink);
        setvideolink(fulllink);
      } else {
          console.error("Could not extract filename from:", fileUrl);
      }
    } else {
      console.warn("No video data in location.state");
    }
  }, [location]);

  const handledwvideo = async (formData) => {
    // console.log(formData);
    // setLoading(true); // Start loading
     
     try {
       console.log(formData);
       const response = await dwvideofromWebService(formData);
       if (response) {
        // console.log(response);
//         navigate('/GetImages', { state: { response } });
//         return setImage(response);
        } else {
         return console.log('error');
       }
     } catch (error) {
       console.error('Error handling form submission:', error);
     }
   };


 /* const data = {
    key: '850Q',
    // Other data to send
  };

*/
    //Cookies.remove('cookieName');

  //  const localvalue = localStorage.getItem('loglevel');
    //data[]=Array('localval')
  // const combineara=[...data,localvalue]
    //sendDataToWebService (combineara);
  return (
    <>
      
      <div className="short-creator-block">
        <div class="short-ready-container">
          <div class="short-ready-wrap">
            <img class="mx-auto mb-6" src={`${process.env.PUBLIC_URL}/images/check-gradient.svg`} alt="Check"/>
            <h3 class="mb-4 text-center">Viral short is ready!</h3>
          {/* <button type='button' onClick={() => handledwvideo(videolink)} class="btn btn-gradient">Download short</button> */}
           <a 
             href={videolink} 
             target="_blank"
             rel="noreferrer"
             download
             class="btn btn-gradient downbtn"
           >Download short</a>
               {/* <div class="share-options">
              <h5 class="mb-4 text-center">Share short on:</h5>
              <div class="share-btns">
                <a href="#!"><img src="images/tiktok.svg" alt="TikTok"/></a>
                <a href="#!"><img src="images/youtube.svg" alt="youtube"/></a>
                <a href="#!"><img src="images/instagram.svg" alt="Instagram"/></a>
              </div>
                </div>*/}
          </div>
        </div>
   

        <div class="example-part">
          <h6 className="mb-2">AI Example</h6>
          <div className="example-media">
           {/* <img className="media-file" src={`${process.env.PUBLIC_URL}/images/ai-example.jpg`} alt="Example media"/> */}
                <video width="320" height="240" controls autoPlay muted loop>
                  <source src={`${process.env.PUBLIC_URL}/images/sdtez7hexdrmt0cvpsw940fhvr_result_.mp4`} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
          </div>
        </div>
      </div>

      
    </>
  );
}

export default Ready;
